import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../../url_variables';
import { TostMessageContext } from "../../context/TostMessage";
import ReactLoading from 'react-loading';
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaCogs, FaSearch } from "react-icons/fa";
import { IoMdChatboxes } from "react-icons/io";
import { AiOutlineClockCircle } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOutlineDashboard, MdLanguage } from "react-icons/md";
import { SideMenu } from '../../components/sidebar';
import { TopBar } from '../../components/topbar';
import {ButtonSmall, ButtonBlack} from '../../components/buttons';
import {RouteDisplay} from '../../components/route_display';
import { UserContext } from '../../context/UserContext';
import { ClockLoader } from 'react-spinners';

function ManageChildScreen() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [cookies, setCookie, removeCookie] = useCookies();
  const [children, setChildren] = useState([]);
  const {logOutFunction, setUserProfile, userProfile, setCalendarValues} = useContext(UserContext);
  const {setTostMessage} = useContext(TostMessageContext);

  function getInitials (name) {
    return name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .slice(0, 3)
    .toUpperCase();
  }

  useEffect(() => {
    console.log(cookies);
    getChildren();
  }, [])
  const getChildren = async () => {
    setLoading(true);
    try {
        const response = await axios.get(base_url + '/manage-child/view-child-accounts.php', {
            headers: {
                "Content-Type": "multipart/form-data",
                token: cookies?.userProfile?.session,
                main_id: cookies?.userProfile?.main_id,
                sub_id: cookies?.userProfile?.sub_id
            },
        });
        if (response.data.code == 403) {
            setTostMessage({
                messageType: "error",
                message: response.data.response,
            });
            logOutFunction()
        }
        if (response.data.status) {
            setLoading(false);
            setChildren(response.data.results);
        } else {
            setLoading(false);
            setTostMessage({
                messageType: "error",
                message: response.data.response,
            });
        }
    } catch (error) {
        setLoading(false);
        setTostMessage({
            messageType: "error",
            message: 'Network error',
        });
    }
  }

  function switchChild(id, name) {
    // setUserProfile({});
    setCalendarValues([]);
    removeCookie("userProfile", { path: "/" });
    const date = new Date();
    let expiresDate = date.setTime(date.getTime() + 24 * 60 * 60 * 1000); // 24 hours
    setUserProfile({...userProfile, sub_id: id, sub_name: name, name: name, account_type: 'sub'});
    setCookie("userProfile", {...userProfile, sub_id: id, sub_name: name, name: name, account_type: 'sub'}, {
        path: "/",
        maxAge: expiresDate,
        secure: true,
    });
    navigate('/home');
  }

  return (
    <div className="relative h-screen h-full">
        <div className="flex h-screen bg-white">
            {/* Sidebar */}
            <SideMenu />
            {/* Main content */}
            <main className="flex-1 p-8 overflow-y-auto w-full h-full">
                {/* Header */}
                <TopBar />
                <RouteDisplay />
                <div className='w-full mt-3 flex justify-end'>
                    <ButtonSmall loading={false} onPress={() => navigate('/create-child')} label={'Add New Child'} />
                </div>
                {loading ? (
                    <div className='flex justify-center items-center w-fill-available h-full z-[999999] bg-[#ffffff] opacity-[0.6] fixed top-0'>
                        <ClockLoader
                            color={'#F4D00F'}
                            loading={loading}
                            size={60}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                        />
                    </div>
                ) : (
                <div className='flex inline-flex flex-wrap justify-start w-full mt-3'>
                    {children?.map((child, index) => {
                        return (
                            <div key={child.id} className='flex w-full lg:w-[32%] flex-row justify-between mr-3 mt-5'>
                                <div className="bg-yellow-light rounded-xl p-6 w-full max-w-md">
                                    {/* Header */}
                                    <div className="flex items-center justify-between bg-white p-4 py-[2rem] rounded-lg">
                                        <div className="flex items-center space-x-4">
                                        <div className="w-16 h-16 bg-orange rounded-full flex items-center justify-center text-white font-bold text-xl">
                                            {getInitials(child.name)}
                                        </div>
                                        <div>
                                            <h3 className="font-semibold text-[15px] text-gray-800">{child.name}</h3>
                                            <p className="text-gray-500 text-[12px]">Last seen : {child.last_seen}</p>
                                        </div>
                                        </div>
                                        <div className="text-right text-[12px] ml-2">
                                            <p className="text-orange font-semibold">{child.streak} Day(s)</p>
                                            <p className="text-orange font-semibold">Streak</p>
                                        </div>
                                    </div>

                                    {/* Languages */}
                                    <div className="mt-4 bg-white p-4 py-[1.5rem] rounded-lg">
                                        <h4 className="text-sm font-semibold mb-3 text-gray-700">
                                        Enrolled Languages
                                        </h4>
                                        <div className="flex flex-wrap gap-2">
                                        {child?.active_classes_enrrolled.map((lang, index) => (
                                            <span
                                            key={index}
                                            className="bg-peach text-sm px-3 py-1 rounded-full text-gray-800"
                                            >
                                            {lang}
                                            </span>
                                        ))}
                                        </div>
                                    </div>
                                    <div className='mt-4'>
                                        <ButtonBlack loading={false} onPress={() => switchChild(child.sub_id, child.name)} label={`Manage ${child.name}`} />
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
                )}
            </main>
        </div>
    </div>
  );
}

export default ManageChildScreen;
